import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { load as loadOffices } from './actions';
import {
  getOffices,
  isOfficesLoaded,
  isOfficesLoading,
  isOfficesLoadError
} from './model';

export const useOffices = () => {

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(loadOffices());
  }, [dispatch]);

  const { offices, isLoaded, isLoading, isError } = useSelector((state) => ({
    offices: getOffices(state),
    isLoaded: isOfficesLoaded(state),
    isLoading: isOfficesLoading(state),
    isError: isOfficesLoadError(state),
  }));

  return { offices, isLoaded, isLoading, isError };
};
